module.exports = __webpack_public_path__ + "img/icon-ai-change-line@3x.9f1d77dc.png";